import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const HeroSection = () => {
  const scrollToApplication = () => {
    const element = document.getElementById('jetzt-bewerben');
    if (element) {
      element?.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative bg-gradient-to-br from-primary via-brand-primary to-accent text-white overflow-hidden">
      <div className="absolute inset-0 bg-black/10"></div>
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 lg:py-32">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div className="space-y-8">
            <div className="space-y-4">
              <div className="inline-flex items-center space-x-2 bg-white/10 backdrop-blur-sm rounded-full px-4 py-2 text-sm font-medium">
                <Icon name="Briefcase" size={16} />
                <span>Karrierechancen bei AdvoCall</span>
              </div>
              <h1 className="text-4xl lg:text-6xl font-bold leading-tight">
                Gestalten Sie die
                <span className="block text-conversion-accent">
                  Zukunft der Rechtsberatung
                </span>
              </h1>
              <p className="text-xl text-white/90 leading-relaxed max-w-2xl">
                Werden Sie Teil unseres innovativen Teams und revolutionieren Sie die telefonische Rechtsberatung. Flexible Arbeitszeiten, attraktive Vergütung und professionelle Entwicklungsmöglichkeiten erwarten Sie.
              </p>
            </div>
            
            <div className="flex flex-col sm:flex-row gap-4">
              <Button
                variant="default"
                size="lg"
                iconName="FileText"
                iconPosition="left"
                onClick={scrollToApplication}
                className="bg-conversion-accent hover:bg-cta text-white cta-button">
                Jetzt bewerben
              </Button>
              <Button
                variant="outline"
                size="lg"
                iconName="Play"
                iconPosition="left"
                className="border-white text-white hover:bg-white hover:text-primary">
                Mehr erfahren
              </Button>
            </div>
          </div>
          
          <div className="relative">
            <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 space-y-6">
              <div className="flex items-center space-x-4">
                <div className="w-12 h-12 bg-conversion-accent rounded-full flex items-center justify-center">
                  <Icon name="Scale" size={24} color="white" />
                </div>
                <div>
                  <h3 className="text-lg font-semibold">Zugelassene Anwälte</h3>
                  <p className="text-white/80">Arbeiten in einem professionellen Netzwerk</p>
                </div>
              </div>

              <div className="flex items-center space-x-4">
                <div className="w-12 h-12 bg-trust-builder rounded-full flex items-center justify-center">
                  <Icon name="Clock" size={24} color="white" />
                </div>
                <div>
                  <h3 className="text-lg font-semibold">24/7 Flexibilität</h3>
                  <p className="text-white/80">Arbeiten Sie wann Sie möchten</p>
                </div>
              </div>

              <div className="flex items-center space-x-4">
                <div className="w-12 h-12 bg-warning rounded-full flex items-center justify-center">
                  <Icon name="TrendingUp" size={24} color="white" />
                </div>
                <div>
                  <h3 className="text-lg font-semibold">Sichere Vergütung</h3>
                  <p className="text-white/80">Pauschale Vergütung pro Telefonat</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;